<template>
  <v-container fluid>
    <v-card class="border-top-blue">
      <v-card-text>
        <facts-list></facts-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FactsList from '../components/FactsList';

export default {
  name: 'facts-page',
  components: {
    FactsList
  }
};
</script>
